import type { ConsolidationLoanOffer } from "@client/routes/journey/thank-you/pages/moneylion-consolidation-offers";

import type SecondaryOffer from "@packages/types/front-end-api/secondary-offer";

const MONTHS_PER_YEAR = 12;

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const aprFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

function formatCurrency(amount: number) {
  return currencyFormatter.format(amount);
}

function formatApr(apr: number) {
  return `${aprFormatter.format(apr)}%`;
}

function formatYears(years: number) {
  return years === 1 ? "1 year" : `${years} years`;
}

function formatTerm(length: number, unit: string) {
  if (unit === "year" || unit === "years") {
    return formatYears(length);
  }

  if (unit === "month" || unit === "months") {
    if (length % MONTHS_PER_YEAR === 0) {
      return formatYears(length / MONTHS_PER_YEAR);
    }

    return length === 1 ? "1 month" : `${length} months`;
  }

  return `${length} ${unit}`;
}

function getQualification(
  offer: SecondaryOffer,
): ConsolidationLoanOffer["qualification"] {
  if (offer.pre_approved) {
    return "approved";
  }

  if (offer.pre_qualified) {
    return "qualified";
  }

  return undefined;
}

export default function mapConsolidationLoanOffers(
  offers: SecondaryOffer[],
): ConsolidationLoanOffer[] {
  return offers.map((offer, index) => ({
    qualification: getQualification(offer),
    loanType: offer.product_sub_type,
    logoUrl: offer.image_url,
    estMonthlyPayment: formatCurrency(offer.monthly_payment),
    termOfLoan: formatTerm(offer.term_length, offer.term_unit),
    loanAmount: formatCurrency(offer.max_amount),
    fixedApr: formatApr(offer.max_apr),
    disclaimer: offer.disclaimer,
    description: offer.description,
    href: offer.link,
    bestMatch: index === 0,
    offerId: offer.offer_id,
  }));
}
